import React from 'react';
import CohortQueryDropdown from './CohortQueryDropdown';

const selectedQueries = (queries, byId) => queries
  .filter((r) => (r.selected === true))
  .map((r) => (byId ? r.id : r.uuid));

const CohortQueriesDropdown = ({
  byId,
  className,
  disabled,
  errors = [],
  message,
  onChange,
  queries,
  readStatus,
}) => (
  <CohortQueryDropdown
    byId={byId}
    className={className}
    disabled={disabled}
    errors={errors}
    message={message}
    multiple
    onChange={onChange}
    queries={queries}
    readStatus={readStatus}
    value={selectedQueries(queries, byId)}
  />
);

export default CohortQueriesDropdown;
